import {RejectReason} from '../../admin-config/reject-reasons/reject-reason/reject-reason';

export class AppealReason {
  id: string;
  description: string;
  rejectReason: RejectReason;
}
